// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_Nn2","cls2":"TranslationModal-cls2_oUv TranslationModal-cls1_Nn2"};